import { FeedbackModalService } from "./../../../shared/feedback-modal/feedback-modal.service";
import { FeedbackModalComponent } from "./../../../shared/feedback-modal/feedback-modal.component";
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from "@angular/common";
import { MasterService } from "../../master/services/master-service";
import { DataService } from "../../../shared/service/data.service";
import { CommonConstants } from "../../../shared/constants";
import { CommonHelper } from "../../../helper/helper.component";
import { ActivatedRoute, Router } from "@angular/router";
import { FileUploader } from "ng2-file-upload";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker/bs-datepicker.config";

@Component({
  selector: "app-grievance-register",
  templateUrl: "./grievance-register.component.html",
  styleUrls: ["./grievance-register.component.scss"],
  providers: [MasterService, DatePipe, CommonHelper],
})
export class GrievanceRegisterComponent implements OnInit, OnDestroy {
  placeData: any;
  severityData: any;
  feedBackData: any;
  statesData: any;
  registerGrievancesData: any;
  registerGrevianceForm: FormGroup;
  submitted: boolean = false;
  newData: any;
  designationsData: any;
  categories: any;
  categoriesNature: any[] = [];
  institutionData: any;
  talukasData: any;
  villagesData: any;
  districtsData: any;
  submitName: String;
  editGrievanceData: any;
  addGrievance: boolean = true;
  selectboxdisabled: boolean = false;
  dashboard: any;
  maxDate: any = new Date();
  selectedState: any;
  modalView: boolean = false;
  sId: number;
  gCategory: any = [];
  sCategory: any = [];
  selCategory: any;
  startDateTime: any;
  maxDateJoin = new Date();
  selectedStateId: any;
  public uploader: FileUploader = new FileUploader({ url: "" });
  imageData = [];
  @ViewChild("district") district: ElementRef;
  @ViewChild("sinhalaTextInput") sinhalaTextInput: ElementRef;

  @ViewChild("priewimage") private UploadedImage: ElementRef;
  selectedInstitutionType: any;
  institutionTypeData: any;
  institutionTypeRecord: [{ id: number, name: string }]
  selecteddistrictId: any;
  genderData: any;
  talukId: any;
  referenceDate: any;

  grievenceId = this.route.snapshot.params["id"];
  showPickerStart = false;
  constructor(
    private spinner: NgxSpinnerService,
    private masterService: MasterService,
    public datepipe: DatePipe,
    private fb: FormBuilder,
    private commonHelper: CommonHelper,
    private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private feedbackModalService: FeedbackModalService,
    public dataService: DataService
  ) { }

  ngOnInit() {
    let formData = localStorage.getItem("formData");
    if (formData) {
      this.submitName = "Update Grievance";
      this.dashboard = "/supervisor-dashboard";
      this.editGrievanceData = JSON.parse(formData);
      this.addGrievance = false;
      this.selectboxdisabled = true;
      this.getDistricts(this.editGrievanceData.state.stateId);
    } else if (this.dataService.editGrievanceDetails == "addGrievanceDetails") {
      this.submitName = "New Grievance";
      this.dashboard = "/dashboard";
      this.addGrievance = true;
      this.selectboxdisabled = false;
    }
    this.severityValues();
    this.getStates();
    this.getDesignations();
    this.getCategory();
    this.getInstitutionType();

    this.getInstitution(
      this.editGrievanceData.state.stateId,
      this.editGrievanceData.district.districtId
    );
    this.getGrievanceCategory();
    let mobileNo = localStorage.getItem("mobileNo");
    let cmpname = localStorage.getItem("name");
    this.grievanceRegisterValidations(mobileNo, cmpname);
    this.genderData = CommonConstants.gender;
  }

  ngOnDestroy() {
    this.dataService.editGrievanceDetails = "addGrievanceDetails";
    this.addGrievance = true;
  }

  severityValues() {
    try {
      this.spinner.show();
      this.masterService.getAll("active_grievanceType").subscribe(
        (response: any) => {
          if (response.status == 200) {
            let newData = [];
            this.spinner.hide();
            response.data.filter((newResponse) => {
              newData.push({
                id: newResponse.grievanceTypeId,
                name: newResponse.name,
              });
            });
            if (newData.length > 0) {
              this.spinner.hide();
              this.severityData = newData;
            } else {
              this.severityData = [];
            }
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /** getStates
   *
   * @param isStates
   */
  getStates() {
    try {
      this.spinner.show();
      this.masterService.getAll("active_states").subscribe(
        (response: any) => {
          if (response.status) {
            if (response.data.length > 0) {
              this.spinner.hide();
              this.statesData = response.data.map((x) => {
                return {
                  id: x.id,
                  name: x.name,
                };
              });
              let selectedValue: any;
              response.data.forEach((element) => {
                if (element.id == CommonConstants.stateId) {
                  selectedValue = element;
                }
              });
              this.selectedState = response.data;
            } else {
              this.spinner.hide();
            }
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  feedBackValues() {
    this.feedBackData = [
      { id: 1, name: "Satisfied" },
      { id: 2, name: "Dissatisfied" },
    ];
  }
  /**GetDistricts
   *
   * @param stateId
   */
  getDistricts(stateId: number) {
    this.apiCalling("active_districts", stateId);
  }

  /**GetTalukas
   *
   * @param districtId
   */
  getTalukas(districtId: number) {
    this.apiCalling("active_talukas", districtId);
  }

  /**getVillages
   *
   * @param talukaId
   */
  getVillages(talukaId: number) {
    this.apiCalling("active_villages", talukaId);
  }

  /**getDesignations
   *
   *
   */
  getDesignations() {
    this.apiCallingOnload("active_designations");
  }

  /**getCategory
   *
   *
   */
  getCategory() {
    this.apiCallingOnload("active_grievanceType");
  }

  /**getGrievanceNature
   *
   * @param stateId
   */
  getGrievanceNature(id) {
    this.apiCalling("active_grievanceNature", id);
  }

  onChangeOfCategory(event) {
    this.getGrievanceNature(event.grievanceTypeId);
  }

  // function for getting grievanceNature
  getGrievanceCategory() {
    try {
      this.spinner.show();
      this.masterService.getAll("active_grievanceCategory").subscribe(
        (response: any) => {
          if (response.status == 200) {
            let newData = [];
            this.spinner.hide();
            response.data.filter((newResponse) => {
              newData.push({
                id: newResponse.grievanceCategoryId,
                name: newResponse.grievanceCategoryName,
              });
            });
            if (newData.length > 0) {
              this.spinner.hide();
              this.gCategory = newData;
            } else {
              this.gCategory = [];
            }
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  onCategoryChange(value) {
    this.selCategory = value.id;
    this.getGrievanceSubcategory(this.selCategory);
  }

  // function for getting grievanceNature
  getGrievanceSubcategory(id) {
    try {
      this.spinner.show();
      this.masterService.getData("active_grievancesubCategory/", id).subscribe(
        (response: any) => {
          if (response.status) {
            let newData = [];
            this.spinner.hide();
            response.data.filter((newResponse) => {
              newData.push({
                id: newResponse.grievanceSubCategoryId,
                name: newResponse.grievanceSubCategoryName,
              });
            });
            if (newData.length > 0) {
              this.spinner.hide();
              this.sCategory = newData;
            } else {
              this.sCategory = [];
            }
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  onSubCategoryChange(value) {
    this.sId = value.id;
  }

  setFocus(el): void {
    setTimeout(() => el.focus(), 0);
  }

  getInstitution(state_id, district_id) {
    try {
      this.spinner.show();
      this.masterService
        .getAll("active_institutions/" + state_id + "/" + district_id)
        .subscribe(
          (response: any) => {
            if (response.status == 200) {
              let newData = [];
              this.spinner.hide();
              response.data.filter((newResponse) => {
                newData.push({ id: newResponse.id, name: newResponse.name });
              });
              if (newData.length > 0) {
                this.spinner.hide();
                this.institutionData = newData;
              } else {
                this.spinner.hide();
                this.institutionData = [];
              }
            }
            else {
              this.spinner.hide();
            }
          },

          (error) => { }
        );
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + "/", id).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          //this.modalRef.hide();
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  apiCallingOnload(url: string) {
    try {
      this.spinner.show();
      this.masterService.getAll(url).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**Databinding to UI
   *
   * @param url
   * @param response
   */
  dataBinding(url: string, response: any) {
    if (url === "active_districts") {
      if (response.data[0].districts.length > 0) {
        this.spinner.hide();

        this.districtsData = response.data[0].districts.map((x) => {
          return {
            districtId: x.districtId,
            districtName: x.name,
          };
        });
      } else {
        this.districtsData = [];
        this.spinner.hide();
      }
    } else if (url === "active_talukas") {
      this.villagesData = [];
      if (response.data[0].talukas.length > 0) {
        this.spinner.hide();
        this.talukasData = response.data[0].talukas;
      } else {
        this.talukasData = [];
        this.spinner.hide();
      }
    } else if (url === "active_villages") {
      if (response.data[0].villages.length > 0) {
        this.spinner.hide();
        this.villagesData = response.data[0].villages;
      } else {
        this.villagesData = [];
        this.spinner.hide();
      }
    } else if (url === "active_designations") {
      if (response.data.length > 0) {
        this.spinner.hide();
        this.designationsData = response.data;
      } else {
        this.designationsData = [];
        this.spinner.hide();
      }
    } else if (url === "active_grievanceType") {
      if (response.data.length > 0) {
        this.spinner.hide();
        this.categories = response.data;
      } else {
        this.spinner.hide();
        this.categories = [];
      }
    } else if (url === "active_grievanceNature") {
      let newData = [];
      response.data.filter((newResponse) => {
        newData.push({
          id: newResponse.grievanceNatureId,
          name: newResponse.grievanceNatureName,
        });
      });

      if (newData.length > 0) {
        this.spinner.hide();
        this.categoriesNature = newData;
      } else {
        this.spinner.hide();
        this.categoriesNature = [];
      }
    } else if (url === "active_institute_type") {
      if (response.data[0].instituteTypeList.length > 0) {
        this.spinner.hide();
        this.selectedInstitutionType =
          this.selectedInstitutionType == null
            ? 0
            : response.data[0].instituteTypeList[0];
        this.institutionTypeData = response.data[0].instituteTypeList;
      } else {
        this.spinner.hide();
        this.institutionTypeData = [];
        this.selectedInstitutionType = [];
      }
    } else {
      this.spinner.hide();
    }
  }
  /**empty by default
   *
   */
  emptyByDefault() {
    this.districtsData = [];

    this.registerGrevianceForm.get("filterDistrictName").setValue([]);
  }

  /**
   * Add form control function
   */
  get rgComplainantNamenF() {
    return this.registerGrevianceForm.controls;
  }

  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: "DD-MM-YYYY",
  };

  /**grievanceRegisterValidations making rg as registerGrievance in starting
   *
   */
  grievanceRegisterValidations(mobileNo: any, cmpname: string) {
    this.submitted = false;
    if (this.addGrievance == true) {
      this.registerGrevianceForm = this.fb.group({
        rgComplainantName: [
          "",
          [
            Validators.maxLength(CommonConstants.maxLength150),
            Validators.pattern(CommonConstants.regexNotAllowSpecialCharacters),
          ],
        ],
        rgBlockName: [
          [],
          [

            Validators.pattern(CommonConstants.regexNotAllowSpace),
          ],
        ],
        rgSubjectComplainant: [
          [],
          [
            Validators.required,
            Validators.pattern(CommonConstants.regexNotAllowSpecialCharacters),
          ],
        ],
        rgComplainantId: [[]],
        rgRegisterByComplainant: [[]],
        rgComplainantMobileNum: [
          "",
          [
            Validators.required,
            Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber),
          ],
        ],
        rgBriefOfGrievance: [
          "",
          [
            Validators.required,
            Validators.maxLength(CommonConstants.maxLength2500),
          ],
        ],
        rgSeverity: ["", [Validators.required]],
        rgComplainantAgainst: [
          "",
          [
            Validators.required,
            Validators.pattern(CommonConstants.regexNotAllowSpecialCharacters),
          ],
        ],

        filterGrievanceInstitution: [[]],
        feedbackType: [[], Validators.required],
        rgSelectDate: ["", Validators.required],
        filterStateName: [[], Validators.required],
        filterDistrictName: [[], Validators.required],
      });
    } else if (this.addGrievance == false) {
      let grievenceStateData = {
        id: this.editGrievanceData.state.stateId,
        name: this.editGrievanceData.state.stateName,
      };
      let complaint_against = {
        designationsId: this.editGrievanceData.designation.designationId,
        name: this.editGrievanceData.designation.designationName,
        description: this.editGrievanceData.designation.description,
        status: this.editGrievanceData.designation.status
      };

      this.referenceDate = this.editGrievanceData.complainDate;
      this.startDateTime = this.editGrievanceData.complainDate;

      this.registerGrevianceForm = this.fb.group({
        rgComplainantName: [
          this.editGrievanceData.firstName,
          [
            Validators.maxLength(CommonConstants.maxLength150),
            Validators.pattern(CommonConstants.regexNotAllowSpecialCharacters),
          ],
        ],
        rgBlockName: [
          this.editGrievanceData.block,
        ],
        rgSubjectComplainant: [
          this.editGrievanceData.subject,
        ],
        rgComplainantId: [this.editGrievanceData.complainId],
        rgRegisterByComplainant: [
          this.editGrievanceData.registerBy.CreatedByName,
        ],
        rgComplainantMobileNum: [
          this.editGrievanceData.phoneNumber,
          [
            Validators.required,
            Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber),
          ],
        ],
        rgBriefOfGrievance: [
          this.editGrievanceData.details,
          [
            Validators.maxLength(CommonConstants.maxLength2500),
          ],
        ],
        rgSeverity: [
          this.editGrievanceData.severity.severityName,
        ],
        rgComplainantAgainst: [complaint_against],

        filterGrievanceInstitution: [this.editGrievanceData.institute.instituteName],
        feedbackType: [
          this.editGrievanceData.feedback.feedbackName,
        ],
        rgSelectDate: [
          this.editGrievanceData.complainDate,
          Validators.required,
        ],
        filterStateName: [grievenceStateData],
        filterDistrictName: [
          this.editGrievanceData.district,
        ],
      });
      this.registerGrevianceForm.enable();
    }
  }

  /**
   *
   */
  createGrievance() {
    try {
      this.submitted = true;
      let apiData = this.registerGrevianceForm.value;
      let genderMap = { male: 1, female: 2, transgender: 3 };

      let data;
      if (this.addGrievance == true) {
        setTimeout(() => {
          data = {
            complainantName: apiData.rgComplainantName,
            blockName: apiData.rgBlockName,
            subjectName: apiData.rgSubjectComplainant,
            complainantMobileNum: apiData.rgComplainantMobileNum,
            description: apiData.rgBriefOfGrievance,
            grievanceInstitutionId:
              apiData.filterGrievanceInstitution.institueId,
            grievanceCategoryId: apiData.feedbackType.id,
            grievanceStateId: CommonConstants.stateId,
            grievanceDistrictId: apiData.filterDistrictName.districtId,
            against: apiData.rgComplainantAgainst,
            referenceDate: this.datepipe.transform(
              apiData.rgSelectDate,
              "yyyy-MM-dd HH:mm"
            ),
            severity:
              apiData.rgSeverity == null
                ? ""
                : apiData.rgSeverity.name.toLowerCase(),
          };
          this.apiCallingForPostData("beneficiary/register_grievance", data);
        }, 500);
      } else if (this.addGrievance == false) {
        setTimeout(() => {
          data = {
            first_name: apiData.rgComplainantName,
            block: '',
            grievance_subject: apiData.rgSubjectComplainant,

            phone_number: apiData.rgComplainantMobileNum,
            grievance_details: apiData.rgBriefOfGrievance,
            instituteId:
              apiData.filterGrievanceInstitution ==
                this.editGrievanceData.institute.instituteName
                ? Number(this.editGrievanceData.institute.institueId)
                : apiData.filterGrievanceInstitution.id,
            grievanceCategoryId:
              apiData.feedbackType ==
                this.editGrievanceData.feedback.feedbackName
                ? Number(this.editGrievanceData.feedback.feedbackId)
                : apiData.feedbackType.id,
            state_id: apiData.filterStateName.id,
            district_id: apiData.filterDistrictName.districtId,
            complain_against: apiData.rgComplainantAgainst.name,
            complain_against_id: apiData.rgComplainantAgainst.designationsId,
            severity:
              apiData.rgSeverity == this.editGrievanceData.severity.severityName
                ? Number(this.editGrievanceData.severity.severityId)
                : apiData.rgSeverity.id,
            complain_date: this.datepipe.transform(
              apiData.rgSelectDate,
              "yyyy-MM-dd"
            ),
          };

          this.apiCallingForPutData(
            "supervisor/grievance_update/",
            this.grievenceId,
            data
          );
        }, 500);
      }
    } catch (excp) { }
  }

  /* For Creating the Grievance*/
  apiCallingForPostData(url: string, data: any) {
    try {
      this.spinner.show();
      this.masterService.postData(url, data).subscribe(
        (response: any) => {
          localStorage.setItem("grievanceId", response.data.grievanceId);
          if (response.status) {
            this.spinner.hide();
            if (url === "beneficiary/register_grievance") {
              this.commonHelper.toasterMessage(response.message);
              this.uploader.queue = [];
              this.openViewModal();
            } else if (url === "helpdesk/register_grievance") {
              this.commonHelper.toasterMessage(response.message);
              this.openViewModal();
            } else {
              this.spinner.hide();
            }
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) { }
  }

  openViewModal() {
    this.feedbackModalService.open();
  }

  /* for updating the grievances */
  apiCallingForPutData(url: string, id: number, data: any) {
    try {
      this.spinner.show();
      this.masterService.post_Data(url, id, data).subscribe(
        (response: any) => {
          if (response.status) {
            this.spinner.hide();
            this.commonHelper.toasterMessage(response.message);
            this.router.navigate(["/supervisor-dashboard"]);
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) { }
  }
  /**StateChange
   *
   * @param event
   */
  onStateChange(event: any) {
    this.getDistricts(event.id);
    this.selectedStateId = event.id;

    this.emptyByDefault();
  }

  /**DistrictChange
   *
   * @param event
   */
  onDistrictChange(event: any) {
    this.selectedStateId =
      this.selectedStateId == undefined
        ? this.editGrievanceData.state.stateId
        : this.selectedStateId;
    this.selecteddistrictId = event.districtId;
    this.getInstitution(this.selectedStateId, this.selecteddistrictId);
    console.log(this.registerGrevianceForm)
  }

  /**onTalukaChange
   *
   * @param event
   */

  onTalukaChange(event: any) {
    this.getVillages(event.talukaId);
    if (this.addGrievance == true) {
      this.talukId = event.talukaId;
      this.selecteddistrictId = this.selecteddistrictId;
      this.selectedInstitutionType =
        this.selectedInstitutionType.instituteTypeId == undefined
          ? 0
          : this.selectedInstitutionType.instituteTypeId;
    } else if (this.addGrievance == false) {
      this.talukId = event.talukaId;
      this.selectedInstitutionType =
        this.selectedInstitutionType.instituteTypeId == undefined
          ? 0
          : this.selectedInstitutionType.instituteTypeId;
      this.selecteddistrictId =
        this.selecteddistrictId == undefined
          ? this.editGrievanceData.districts.id
          : this.selecteddistrictId;
    }
  }

  onTypeChange(event) {
    if (this.addGrievance == true) {
      this.selectedInstitutionType = event.instituteTypeId;
      this.talukId = this.talukId == undefined ? 0 : this.talukId;
      this.selecteddistrictId = this.selecteddistrictId;
    } else if (this.addGrievance == false) {
      this.selectedInstitutionType = event.instituteTypeId;
      this.talukId = this.talukId == undefined ? 0 : this.talukId;
      this.selecteddistrictId =
        this.selecteddistrictId == undefined
          ? this.editGrievanceData.districts.id
          : this.selecteddistrictId;
    }

    if (!this.selecteddistrictId && this.addGrievance == true) {
      this.setFocus(this.district);
      return;
    }
  }

  backTo() {
    this.router.navigate(["/supervisor-dashboard"]);
  }

  onValueChange(val: any) {
    val = this.datepipe.transform(val, "yyyy-MM-dd");
    this.startDateTime = val;
    this.submitted = false;
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == "startDT") {
      if (!this.showPickerStart) {
        this.showPickerStart = true;
      }
    }
  }

  private getInstitutionType(): void {
    this.masterService.getInstitutionType('institute_types').subscribe((response: any) => {
      next: {
        this.spinner.hide();
        this.institutionTypeRecord = response.data;
      }
      error: (error) => {
        this.commonHelper.toasterMessage(response.message);
        this.spinner.hide();
      }

    });
  }
}
